import { CalculateGeometric } from './CalculateGeometric';
import { CalculateSine } from './CalculateSine';
import { CalculateEvenly } from './CalculateEvenly';

interface sourceInterface {
  r: number[],
  g: number[],
  b: number[]
}

interface createScaleInterface {
  geometric: number[][],
  sine: number[][],
  evenly: number[][]
}

export const CreateScale = (source: sourceInterface, step: number): createScaleInterface => {
  const 
    resultGeometric = [],
    resultSine =[],
    resultEvenly =[];
  for(let index = 0; index < step; index++) {
    resultGeometric.push([
      CalculateGeometric(source.r[0], source.r[1], step)[index],
      CalculateGeometric(source.g[0], source.g[1], step)[index],
      CalculateGeometric(source.b[0], source.b[1], step)[index]
    ]);
    resultSine.push([
      CalculateSine(source.r[0], source.r[1], step)[index],
      CalculateSine(source.g[0], source.g[1], step)[index],
      CalculateSine(source.b[0], source.b[1], step)[index]
    ]);
    resultEvenly.push([
      CalculateEvenly(source.r[0], source.r[1], step)[index],
      CalculateEvenly(source.g[0], source.g[1], step)[index],
      CalculateEvenly(source.b[0], source.b[1], step)[index]
    ]);
  }
  return {
    geometric: resultGeometric,
    sine: resultSine,
    evenly: resultEvenly
  }
}